"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingType = void 0;
var RatingType;
exports.RatingType = RatingType;
(function (RatingType) {
  RatingType["ByOrganization"] = "byOrganization";
  RatingType["ByProduct"] = "byProduct";
})(RatingType || (exports.RatingType = RatingType = {}));